import moment from "moment";
import { MaintenanceScheduledRequest } from '@/models/maintenance/MaintenanceScheduledRequest';
import {MaintenanceRequestCadences} from "@/enums/MaintenanceRequestCadences";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventLocationsMixin} from "@/mixins/EventLocations";
import {MaintenanceMixin} from '@/mixins/Maintenance';
import {MaintenancePriority} from "@/enums/MaintenancePriority";
import ScheduledMaintenanceAddFormDlg
  from "@/views/maintenance/scheduledMaintenance/scheduledMaintenanceAddFormDlg/ScheduledMaintenanceAddFormDlg.vue";
import * as firebase from "firebase";
import {deleteFileByUrl, optimizePhotos, uploadImageAsync} from "@/utils/upload-image";
import {waitResizedImage} from "@/utils/wait-resized-image";
import {v4 as uuidv4} from "uuid";
import {fileSizeToMB, validFileSize10MB, validVideoSize130MB} from "@/utils/fileSizeToMB";
import {MaintenanceMedia} from "@/models/maintenance/MaintenanceMedia";
import {MaintenanceMediaTypes} from "@/enums/MaintenanceMediaTypes";
import {MaintenanceChecklist} from "@/models/maintenance/MaintenanceChecklist";
import { MaintenanceTypes } from '@/enums/MaintenanceTypes';
import { hasAccess } from "@/utils/accessControl/accessControl";
import { AccessMatrixKeys } from "@/utils/accessControl/accessMatrixKeysEnum";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { RecurringRepeatType } from '@/enums/RecurringEventsType';
import { Week } from '@/consts/Week';
import { RecurringRepeatOnNumber } from '@/enums/RecurringEventsType';
import { RecurringRepeatOnDay } from '@/enums/RecurringEventsType';
import { UserTypeEnum } from '@/enums/UserTypeEnum';
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

export default {
  name: "scheduledMaintenanceDlg",
  mixins: [
    EventLocationsMixin,
    MaintenanceMixin
  ],
  components: {
    ValidationObserver,
    ValidationProvider,
    ScheduledMaintenanceAddFormDlg,
    ConfirmDlg
  },
  data() {
    return {
      dialog: false,
      newMaintenanceRequest: null,
      newVendor: null,
      minDate: moment(new Date()).format("YYYY-MM-DD"),
      isCreate: false,
      isUpdate: false,
      loading: false,
      reqType: null,
      mediaLoading: false,
      selectedMedia: [],
    }
  },
  computed: {
    MaintenanceMediaTypes() {
      return MaintenanceMediaTypes
    },
    MaintenanceTypes() {
      return MaintenanceTypes;
    },
    scheduledMaintenanceRequests() {
      return this.$store.state.maintenanceModule.scheduledMaintenance;
    },
    maintenanceScheduledForms() {
      return this.isCreate ?
        this.newMaintenanceRequest.forms :
        this.$store.state.maintenanceModule.currentSchedMaint?.forms || [];
    },
    maintenanceTypes() {
      return this.$store.state.maintenanceModule.maintenanceTypes;
    },
    currentVendors() {
      return this.$store.state.additionalServicesModule.currentVendors;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    maintenanceCategories() {
      return this.$store.getters.maintenanceCategories;
    },
    MaintenanceRequestCadences() {
      return MaintenanceRequestCadences;
    },
    RecurringRepeatType() {
      return RecurringRepeatType;
    },
    RecurringRepeatOnNumber() {
      return Object.values(RecurringRepeatOnNumber);
    },
    RecurringRepeatOnDay() {
      return Object.values(RecurringRepeatOnDay);
    },
    Week() {
      return Week;
    },
    maintenanceRequestCadences() {
      return Object.values(MaintenanceRequestCadences);
    },
    recurringRepeatType() {
      return Object.values(RecurringRepeatType);
    },
    MaintenanceTechnicians() {
      return [...this.$store.state.userModule.maintenanceUsers, ...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })];
    },
    MaintenanceVendors() {
      return [...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })]
    },
    MaintenanceStaff() {
      return [...this.$store.state.userModule.maintenanceUsers];
    },
    maintenancePriority() {
      return Object.values(MaintenancePriority);
    },
    user() {
      return this.$store.state.authModule.user;
    },
    canAddEventLocation(){
        return hasAccess(this.user.accessLevel, AccessMatrixKeys.Calendar_Events_AddLocation)
    }
  },
  watch: {
    reqType(requestType: any): void {
      if(requestType) {
        this.newMaintenanceRequest.title = requestType?.name;
        this.newMaintenanceRequest.categoryId = requestType?.categoryId;
        this.newMaintenanceRequest.department = requestType?.department;
        this.newMaintenanceRequest.typeId = requestType?.id;
        this.newMaintenanceRequest.icon = requestType?.icon;
      }
    },
    newVendor: {
      handler(vendor) {
        if(vendor !== null && vendor.id !== this.newMaintenanceRequest.assigneeId){
          this.newMaintenanceRequest.assignee = vendor.name;
          this.newMaintenanceRequest.assigneeId = vendor.id;
          this.newMaintenanceRequest.assigneeEmail = vendor.email ?? null;
          this.newMaintenanceRequest.assigneePhoneNumber = vendor?.phoneNumber ?? null;
          this.newMaintenanceRequest.assigneeDate = firebase.firestore.Timestamp.now();
        }
      },
      immediate: false,
    },
    'newMaintenanceRequest.locationId'(locationId) {
      if(locationId != null) {
        this.newMaintenanceRequest.location = this.eventLocations?.find(x => x.id === locationId)?.name ?? '';
      }
    },
    'newMaintenanceRequest.wingId'(wingId) {
      if(wingId != null) {
        this.newMaintenanceRequest.wing = this.wings?.find(x => x.id === wingId)?.name ?? '';
      }
    },
    'newMaintenanceRequest.categoryId'(categoryId) {
      if(categoryId != null) {
        this.newMaintenanceRequest.category = this.maintenanceCategories?.find(x => x.id === categoryId)?.name ?? '';
      }
    },
    'newMaintenanceRequest.cadence'(newValue, oldValue) {
      if(newValue != null && oldValue && this.isUpdate) {
        this.$refs.confirmDlg.open(
          null,
          this.$t("EditDigitalSignage.UpdateCadence"),
          false
        ).then(async response => {
          if (response && response.agree) {
            this.newMaintenanceRequest.nextMaintenance = this.addCadenceInterval({
              cadence: newValue,
              startDate: moment(this.newMaintenanceRequest.startDate ?? new Date()).format("YYYY-MM-DD"),
            });
          }
        })
      }
    },
    'newMaintenanceRequest.startDate'(newValue, oldValue) {
      if(newValue != null && oldValue && this.isUpdate) {
        this.newMaintenanceRequest.endDate = moment(this.newMaintenanceRequest.startDate).add(1, 'month').format("YYYY-MM-DD");
      }
    }
  },
  methods: {
    open(status: string, data?: MaintenanceScheduledRequest) {
      this.dialog = true;

      if(status === "create") {
        this.isCreate = true;
        this.newMaintenanceRequest = new MaintenanceScheduledRequest()
      }

      if(status === "update") {
        this.isUpdate = true;
        this.newMaintenanceRequest = data;
        this.newVendor = this.MaintenanceTechnicians?.filter(x => (x?.id === data?.vendorId) || (x?.id === data?.assigneeId))[0] ?? null;
        this.reqType = this.maintenanceTypes?.find(x => x.id === data?.typeId) ?? null;
      }
    },
    async submit() {
      this.loading = true;

      if(this.isCreate) {
        await this.createMaintenanceSchedule();
      }
      if(this.isUpdate) {
        await this.updateMaintenanceSchedule();
      }
    },
    async createMaintenanceSchedule() {
      this.newMaintenanceRequest.active = true;
      this.newMaintenanceRequest.facilityId = this.facility.id;
      this.newMaintenanceRequest.createdByStaffId = this.user.id;
      this.newMaintenanceRequest.createdByStaffName = this.user.name;
      this.newMaintenanceRequest.createdById = this.user.id;
      this.newMaintenanceRequest.createdByType = UserTypeEnum.Staff
      this.newMaintenanceRequest.typesOfRecordChanged = [`${Tier1.Maintenance}: ${Tier2.ScheduledJob}: ${Tier3.Add}`]

      if(this.newMaintenanceRequest.cadence) {
        const today = moment().format("YYYY-MM-DD");
        if(this.newMaintenanceRequest.startDate === today) {
          // If start date is today, the next request due should be the next cadence date
          this.newMaintenanceRequest.nextMaintenance = this.addCadenceInterval({
            cadence: this.newMaintenanceRequest.cadence,
            startDate: this.newMaintenanceRequest.startDate,
          });
        } else {
          // For future start dates, the first request should be due on the start date
          this.newMaintenanceRequest.nextMaintenance = this.newMaintenanceRequest.startDate;
        }
      }

      let forms = [];
      if(this.newMaintenanceRequest?.forms && this.newMaintenanceRequest?.forms?.length) {
        forms = await this.$store.dispatch("createMaintenanceForms", this.newMaintenanceRequest.forms);
        this.newMaintenanceRequest.forms = this.newMaintenanceRequest.forms.map(x => {
          return {
            locationId: x.locationId,
            name: x.name,
            templateId: x.templateId,
            isMediaEnable: x.isMediaEnable,
          }
        })
      }

      await this.$store
        .dispatch('createScheduledMaintenance', {
          newSched: Object.assign({}, this.newMaintenanceRequest),
          forms: forms,
        })
        .then(() => {
          this.$toast.open({
            message: this.$t("MaintenanceManagement.MaintenanceScheduledSuccessfullyCreated"),
            type: "success"
          });

         this.close();
        }).catch((err) => {
          console.log(err.message)
          this.$toast.open({
            message: this.$t("GeneralTranslations.UnhandledError"),
            type: "error"
          });
          this.loading = false;
        });
    },
    addCadenceInterval({ cadence, startDate }) {
      /*if(startDate !== moment(new Date()).format("YYYY-MM-DD")) {
        return moment(startDate).format("YYYY-MM-DD");
      }*/

      let nextMaintenance = startDate;

      switch (cadence) {
        case 'yearly':
          nextMaintenance = moment(nextMaintenance).add(1, 'year');
          break;
        case 'monthly':
          nextMaintenance = moment(nextMaintenance).add(1, 'month');
          break;
        case 'weekly':
          nextMaintenance = moment(nextMaintenance).add(1, 'week');
          break;
        case 'daily':
          nextMaintenance = moment(nextMaintenance).add(1, 'day');
          break;

        case 'custom':
          if(this.newMaintenanceRequest.recurringRepeatType === "Day") {
            nextMaintenance = moment(nextMaintenance).add(this.newMaintenanceRequest?.recurringRepetitions, 'days');
          }

          if (this.newMaintenanceRequest.recurringRepeatType === "Week") {
            const every = Number(this.newMaintenanceRequest?.recurringRepetitions) || 1;
            const daysOfWeek = this.newMaintenanceRequest?.recurringRepetitionsDays || [];
            const daysInWeek = 7;
            const maxWeeks = 52;

            let next = moment(nextMaintenance).startOf('day');
            let found = false;

            for (let dayOffset = 1; dayOffset <= daysInWeek; dayOffset++) {
              const candidate = moment(next).add(dayOffset, 'day');
              const candidateDay = candidate.format('ddd');

              if (daysOfWeek.includes(candidateDay)) {
                next = candidate.startOf('day');
                found = true;
                break;
              }
            }

            if (!found || !next.isAfter(nextMaintenance)) {
              for (let weekOffset = 1; weekOffset <= maxWeeks; weekOffset++) {
                const weekStart = moment(next).add(every * weekOffset, 'weeks');

                for (let day = 0; day < daysInWeek; day++) {
                  const candidate = moment(weekStart).add(day, 'day');
                  const candidateDay = candidate.format('ddd');

                  if (daysOfWeek.includes(candidateDay)) {
                    next = candidate.startOf('day');
                    found = true;
                    break;
                  }
                }

                if (found) break;
              }
            }

            nextMaintenance = next;
          }

          if (this.newMaintenanceRequest.recurringRepeatType === "Month") {
            const every = Number(this.newMaintenanceRequest?.recurringRepetitions) || 1;
            const repeatOns = this.newMaintenanceRequest?.monthlyRepeatOn || [];

            let found = false;

            while (!found) {
              const candidateDates: moment.Moment[] = [];

              for (const repeat of repeatOns) {
                const position = repeat.position;
                const day = repeat.day;

                const positionMap = {
                  'First': 0,
                  'Second': 1,
                  'Third': 2,
                  'Fourth': 3,
                  'Last': -1,
                };

                const monthStart = moment(nextMaintenance).startOf('month');
                const monthEnd = moment(nextMaintenance).endOf('month');

                const allDays: moment.Moment[] = [];
                const currentDay = monthStart.clone();

                while (currentDay.isSameOrBefore(monthEnd)) {
                  if (currentDay.format('dddd') === day) {
                    allDays.push(currentDay.clone());
                  }
                  currentDay.add(1, 'day');
                }

                let candidateDay: moment.Moment | null = null;

                if (position === 'Last') {
                  candidateDay = allDays[allDays.length - 1];
                } else {
                  const index = positionMap[position];
                  if (allDays[index]) {
                    candidateDay = allDays[index];
                  }
                }

                if (candidateDay && candidateDay.isAfter(nextMaintenance)) {
                  candidateDates.push(candidateDay.startOf('day'));
                }
              }

              if (candidateDates.length > 0) {
                // Знайдемо найменшу дату серед кандидатів
                const earliest = candidateDates.reduce((min, curr) => curr.isBefore(min) ? curr : min);
                nextMaintenance = earliest;
                found = true;
              } else {
                // Переходимо до наступного місяця
                nextMaintenance = moment(nextMaintenance).add(every, 'months').startOf('month');
              }
            }
          }

          break;
      }

      return moment(nextMaintenance).format("YYYY-MM-DD");
    },
    checkMaintenanceForms(forms) {
      return forms.filter(x => x.facilityId && x.status)
    },
    async updateMaintenanceSchedule() {
      if(this.newMaintenanceRequest?.id?.length) {
        let forms = [];
        if(this.newMaintenanceRequest?.forms && this.newMaintenanceRequest?.forms?.length) {
          const newForms = this.checkMaintenanceForms(this.newMaintenanceRequest.forms);

          forms = await this.$store.dispatch("createMaintenanceForms", newForms);
          this.newMaintenanceRequest.forms = this.newMaintenanceRequest.forms.map(x => {
            return {
              locationId: x.locationId,
              name: x.name,
              templateId: x.templateId,
              isMediaEnable: x.isMediaEnable,
            }
          })
        }

        // Note: nextMaintenance is not recalculated during updates to preserve the scheduled date.
        // It's only updated when the cadence is explicitly changed (handled by watcher).

        this.newMaintenanceRequest.updatedById = this.user.id;
        this.newMaintenanceRequest.updatedByType = UserTypeEnum.Staff
        this.newMaintenanceRequest.typesOfRecordChanged = [`${Tier1.Maintenance}: ${Tier2.ScheduledJob}: ${Tier3.Amend}`]
        await this.$store.dispatch("updateScheduledMaintenance", {
          newSched: Object.assign({}, this.newMaintenanceRequest),
          forms: forms,
        })
          .then(async () => {
            await this.$store.dispatch('getScheduledMaintenanceById', this.$route.params.id);
            await this.$store.dispatch('getRequestsByScheduledMaintenanceId', this.$route.params.id);
            await this.$store.dispatch('getMaintenanceFormsByScheduledMaintenanceId', this.$route.params.id)
            this.$toast.open({
              type: "success",
              message: this.$t("MaintenanceSchedule.MaintenanceScheduleUpdateSuccess")
            });
            this.close();
          }).catch((err) => {
            console.log(err.message)
            this.$toast.open({
              type: "error",
              message: this.$t("GeneralTranslations.UnhandledError")
            })
            this.loading = false;
          })
      }
    },
    openPopupWithForm() {
      this.$refs.scheduledMaintenanceAddFormDlg.open()
    },
    close() {
      this.loading = false;
      this.newMaintenanceRequest = {}
      this.newVendor = null;
      this.isCreate = false;
      this.isUpdate = false
      this.dialog = false;
      this.reqType = null;
      this.$refs.form.reset();
      this.$emit("closeEditPopup");
    },
    clearVendor() {
      this.newVendor = null;
      delete this.newMaintenanceRequest.assignee;
      delete this.newMaintenanceRequest.assigneeId;
      delete this.newMaintenanceRequest.assigneeEmail;
      delete this.newMaintenanceRequest.assigneePhoneNumber;
      delete this.newMaintenanceRequest.assigneeDate;
      delete this.newMaintenanceRequest.priority;
    },

    async uploadMedia(e) {
      this.mediaLoading = true;
      const files = e.target.files;

      if (files.length) {
        const promises = [];

        for (let i = 0; i < files.length; i++) {
          const path = `${this.facility.id}/maintenanceScheduled/staff/${uuidv4()}`;
          const isFileVideo = ["video/mp4", "video/webm"].includes(files[i].type);
          const file = isFileVideo ? files[i] : await optimizePhotos(files[i], 'background-image');
          const fileSizeInMegabytes = fileSizeToMB(file?.size);
          const isValidFileSize = isFileVideo ? validVideoSize130MB(fileSizeInMegabytes) : validFileSize10MB(fileSizeInMegabytes);

          if (!isValidFileSize) {
            this.$refs.inputUploadMedia.value = null;
            this.mediaLoading = false;
            return;
          }

          const promise = uploadImageAsync({ path, file })
            .then(async (storage) => {
              const url = await storage.ref.getDownloadURL();
              let thumbnailUrl = null;

              if(!isFileVideo) {
                const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);
                thumbnailUrl = await waitResizedImage(10, resizedImageRef);
              }

              const thumbnail = isFileVideo ? url : thumbnailUrl;
              const type = isFileVideo ? MaintenanceMediaTypes.Video : MaintenanceMediaTypes.Photo;
              this.newMaintenanceRequest.media.push(new MaintenanceMedia(url, thumbnail, type).toObject());

              return true;
            });

          promises.push(promise);
        }

        try {
          await Promise.all(promises).then(() => {
            this.$toast.open({
              message: files.length > 1 ? this.$t('Gallery.SuccessUploadingImages') : this.$t('Gallery.SuccessUploadingImage'),
              type: "success"
            });
            this.clearInputFile();
          })
        } catch (error) {
          console.error("Error uploading images:", error);
        } finally {
          this.mediaLoading = false;
        }
      }
    },
    async deleteMedia(index: number) {
      const media = this.newMaintenanceRequest.media[index];
      const mediaUrl = media?.url;
      const mediaThumbnail = media?.thumbnailUrl;

      await deleteFileByUrl(mediaUrl);
      if(mediaUrl !== mediaThumbnail) {
        await deleteFileByUrl(mediaThumbnail);
      }

      this.newMaintenanceRequest.media.splice(index, 1);
    },
    clearInputFile() {
      const fileInput = document.getElementById('fileInput') as HTMLInputElement;
      fileInput.value = "";
    },

    addItemForChecklist() {
      const label = `Item ${this.newMaintenanceRequest.checklist.length + 1}`;
      this.newMaintenanceRequest.checklist.push(new MaintenanceChecklist(label, false).toObject());
    },
    removeItemFromChecklist(index: number) {
      this.newMaintenanceRequest.checklist.splice(index, 1);
      this.newMaintenanceRequest.checklist.forEach((item, index) => {
        if(item.label.includes("Item")) {
          item.label = `Item ${index + 1} `
        }
      });
    },

    addNewForm(form) {
      if (!Array.isArray(this.newMaintenanceRequest.forms)) {
        this.$set(this.newMaintenanceRequest, 'forms', []);
      }

      this.newMaintenanceRequest?.forms?.push(form);
    },
    async removeForm(index: number) {
      if(this.isCreate) {
        this.newMaintenanceRequest.forms.splice(index, 1);
      } else {
        const form = this.maintenanceScheduledForms[index];
        const result = await this.deleteForm(form, this.newMaintenanceRequest?.id);

        if (result) {
          this.newMaintenanceRequest.forms.splice(index, 1);
        }
      }
    },
    openForm(templateId) {
      window.open(`/maintenanceTemplates/${templateId}`, '_blank').focus();
    },
    nameTemplate(templateId): string {
      return this.$store.state.maintenanceModule.maintenanceTemplates.find(x => x.id === templateId).name;
    },
    openUpdateForm(form, index) {
      this.$refs.scheduledMaintenanceAddFormDlg.open(form, index)
    },
    enableEndDate() {
      this.newMaintenanceRequest.endDate = this.newMaintenanceRequest.noEndDate ? null : moment(this.newMaintenanceRequest.startDate).add('month', 1).format("YYYY-MM-DD");
    },
    addRepeatOption() {
      this.newMaintenanceRequest.monthlyRepeatOn.push({
        position: RecurringRepeatOnNumber.First,
        day: RecurringRepeatOnDay.Monday,
      })
    },
    removeRepeatOption(index) {
      this.newMaintenanceRequest.monthlyRepeatOn.splice(index, 1);
    }
  }
}